import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import GuidePage from "../pages/guide/page";
import SitemapPage from "../pages/sitemap/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/guide/:slug",
    element: <GuidePage />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;